import { Department, findDepartmentById, UserDepartment } from './Department';

export interface User {
	id: string;
	name: string;
	isActive: boolean;
	isSystem?: boolean;
	roles?: Role[];
	departments?: UserDepartment[];
	userDepartments?: UserDepartment[];
}

export interface Role {
	id: number;
	name: string;
	description: string;
}

export interface UserWithName {
	id: string;
	name: string;
}

export interface UserRole {
	userId: string;
	roleId: number;
}

export enum RoleName {
	Admin = 'Admin',
	Approver = 'Approver',
	ContentManager = 'ContentManager',
	DepartmentAdmin = 'DepartmentAdmin',
	Spender = 'Spender',
	SoftwareManager = 'SoftwareManager',
	UserAdmin = 'UserAdmin',
	InvoiceEntry = 'InvoiceEntry',
}

export const administrativeRoles: string[] = [RoleName.Admin, RoleName.DepartmentAdmin, RoleName.UserAdmin];

export const formatRoleName = (name: string): string =>
	name.replace(/([A-Z])/g, ' $1').trim();

export const getUserRoleNames = (user?: User): string[] => {
	let roleNames: string[] = [];

	if (user && user.roles) {
		roleNames = user.roles.map(role => role.name).filter(Boolean);
	}

	return roleNames;
};

export const getUserDepartmentMemberships = (user?: User): UserDepartment[] => {
	if (!user) {
		return [];
	}

	const memberships = user.departments ?? user.userDepartments ?? [];

	return memberships.filter(membership => membership.isActive !== false);
};

export const getEffectiveUserDepartmentMemberships = (user?: User): UserDepartment[] => {
	const memberships = getUserDepartmentMemberships(user);

	return memberships;
};

export const getUserDepartments = (user?: User, departments: Department[] = []): Department[] =>
	getEffectiveUserDepartmentMemberships(user)
		.map(membership => membership.department ?? findDepartmentById(membership.departmentId, departments))
		.filter((department): department is Department => Boolean(department && department.isActive));

export const formatUserDepartmentNames = (user?: User, departments: Department[] = []): string =>
	getUserDepartments(user, departments)
		.map(department => department.name)
		.join(', ');
